<script setup>
import {computed} from "vue";

const props = defineProps(['id', 'label', 'min', 'step', 'max', 'unit', 'placeholder', 'displayMultiplier'])
const model = defineModel()
const unitValue = computed( () => {
    if( Array.isArray( props.unit ) ) {
        return displayValue.value > 1 ? props.unit[1] : props.unit[0];
    } else {
        return props.unit;
    }
} )
const displayValue = computed( {
    get() { // Transform for display
        return props.displayMultiplier ? ( model.value * props.displayMultiplier ).toFixed( decimalPlaces.value ) : model.value;
    },
    set( newDisplayValue ) { // Convert back to model value
        model.value = props.displayMultiplier ? Math.round( newDisplayValue / props.displayMultiplier ) : newDisplayValue;
    }
} )
const decimalPlaces = computed( () => {
    if( props.displayMultiplier ) {
        const split = props.displayMultiplier.toString().split( '.' );
        
        if( 2 === split.length ) {
            return split[1].length;
        } else {
            return 0;
        }
    }
    
    return 0;
} )
</script>

<template>
    <div class="input-with-unit">
        <label v-if="label" :for="id" v-html="label"></label>
        
        <div :class="`compound-input ${unit ? 'has-unit' : ''}`">
            <input type="text" inputmode="numeric" :id="id" :min="min" :step="step" :max="max" :placeholder="placeholder" v-model="displayValue" :disabled="!!displayMultiplier" required>
            <span class="unit" v-html="unitValue"></span>
        </div>
    </div>
</template>
